import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export default function TikTokIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const width = t1 === undefined ? 28 : t1;
  const height = t2 === undefined ? 28 : t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M20.54 10.34v2.555a6.718 6.718 0 01-3.538-1.432v5.162l-.011-.016a4.656 4.656 0 01-4.64 4.963A4.656 4.656 0 017.7 16.92a4.657 4.657 0 015.389-4.593v2.517a2.205 2.205 0 00-2.94 2.076c-.001 1.215.987 2.202 2.201 2.202a2.206 2.206 0 002.2-2.339V6.752h2.552c.01.216.018.434.027.65.017.426.169.834.433 1.169.31.393.768.85 1.41 1.215.602.34 1.167.487 1.567.556v-.002z" fill="#000" />;
    t4 = <path d="M14.03 28h-.06C6.266 28 0 21.733 0 14.03v-.06C0 6.266 6.267 0 13.97 0h.06C21.734 0 28 6.267 28 13.97v.06C28 21.734 21.733 28 14.03 28zM13.97.948C6.788.948.947 6.788.947 13.969v.062c0 7.18 5.84 13.021 13.021 13.021h.062c7.18 0 13.021-5.84 13.021-13.021v-.062c0-7.18-5.84-13.021-13.021-13.021h-.062z" fill="#000" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== height || $[7] !== props || $[8] !== width) {
    t5 = <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t3}{t4}</svg>;
    $[6] = height;
    $[7] = props;
    $[8] = width;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}